import { ButtonProps } from "@mui/material";
import styled from "styled-components";

export const Content = styled.div`
  padding: 30px;
  padding-bottom: 0px;
  margin-top: 100px;
  width: 100%;
  background-color: #f5f5f5;
`;

export const Container = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  margin-bottom: 20px;
`;
